<template>
  <b-container id="page-orthoptie">
    <b-row>
      <b-col>
        <h1 class="page-title">L'Orthoptie</h1>
      </b-col>
    </b-row>

    <div id="page-orthoptie-content">
      <b-row
        align-h="center"
        align-v="center"
        data-aos="fade-in"
        data-aos-duration="800"
      >
        <b-col cols="5" class="d-none d-md-block">
          <b-img fluid class="mr-3" :src="images[2]"></b-img>
        </b-col>

        <b-col col cols="12" md="5">
          <h2>Qu'est ce que l'orthoptie ?</h2>
          <p>
            L’orthoptiste est un professionnel de santé paramédical. Il dépiste,
            rééduque, réadapte et explore la fonction visuelle. Le premier
            rendez-vous est généralement un bilan, et à l'issu de celui-ci
            l’orthoptiste propose une <a href="/consultations">prise en charge</a> si nécessaire.
            Le certificat de capacité d’orthoptie est
            un diplôme de niveau bac +3 encadré par les facultés de médecine. L’orthoptiste
            travaille uniquement sur prescription médicale d’un médecin et en étroite collaboration
            avec les autres professionnels de santé (Ophtalmologiste, Opticien, Médecin Généraliste,
            ORL, Neurologue, Endocrinologue, Psychomotricien, Orthophoniste, Ergothérapeute,
            Neuropsychologue…)
          </p>
        </b-col>

        <b-col cols="12" class="d-block d-md-none mb-3">
          <b-img fluid :src="images[2]"></b-img>
        </b-col>
      </b-row>

      <b-row
        align-h="center"
        align-v="center"
        data-aos="fade-in"
        data-aos-duration="800"
      >
        <b-col col cols="12" md="5">
          <h2>Pour qui ?</h2>
          <p>
            Nous pouvons avoir besoin d’orthoptie à tout âge, du jeune
            nourrisson jusqu’à la personne âgée . Le champ de compétence des
            orthoptistes est très varié.
          </p>
        </b-col>

        <b-col cols="5" class="d-none d-md-block">
          <b-img fluid class="mr-3" :src="images[1]"></b-img>
        </b-col>

        <b-col cols="12" class="d-block d-md-none mb-3">
          <b-img fluid :src="images[1]"></b-img>
        </b-col>
      </b-row>

      <b-row
        align-h="center"
        align-v="center"
        data-aos="fade-in"
        data-aos-duration="800"
      >
        <b-col cols="5" class="d-none d-md-block">
          <b-img fluid class="mr-3" :src="images[0]"></b-img>
        </b-col>

        <b-col col cols="12" md="5">
          <h2>Quand consulter ?</h2>
          <p>
            Les orthoptistes du cabinet pourront vous prendre en charge pour un
            dépistage de la vision, un strabisme, une amblyopie (oeil “faible”
            ), une diplopie (vision double), pour des maux de tête (céphalées),
            des vertiges, des difficultés scolaires (saut de ligne, lenteur de
            lecture, difficultés graphiques), un trouble de la vision des
            couleurs, de la basse vision (pathologies oculaires responsables
            d’une acuité visuelle faible), un trouble neurodéveloppemental
            (trouble dys, autisme), une téléconsultation (dépistage de la
            rétinopathie diabétique et renouvellement de lunettes), ou un
            renouvellement de lunettes.
          </p>
        </b-col>

        <b-col cols="12" class="d-block d-md-none mb-3">
          <b-img fluid :src="images[0]"></b-img>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import QuestionMark from "../assets/images/image12.jpg";
import Age from "../assets/images/image18.jpg";
import Quand from "../assets/images/image21.jpg";

export default {
  data() {
    return {
      images: [QuestionMark, Age, Quand],
    };
  },
};
</script>

<style lang="stylus">
/* Import theme colors palette */
@import '../css/palette.styl';

#page-orthoptie img {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

#page-orthoptie .row {
  padding-top: 20px;
  padding-bottom: 20px;
  margin-bottom: 50px;
}

#page-orthopsie .row.with-shadow {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

#page-orthoptie h2 {
  color: $DarkTextColor;
}
</style>
